import { ReactNode, useMemo } from 'react'

import { Flex } from 'antd'
import { Icon, T, Tooltip } from 'govwell-ui'
import { EntityFieldFragment } from 'types/graphql'

import {
  buildApplyFormEvPickerTooltipRows,
  GraphqlIntersectingOtherEntityForEvPickerTooltip,
  mapIntersectingOtherEntitiesForEvPickerTooltip,
} from 'src/components/Selects/EntityVersionSearch/applyFormEvPickerTooltipFields'
import { ColumnData, FieldValueTable } from 'src/components/shared/FieldValueTable'

type Props = {
  fields: EntityFieldFragment[]
  intersectingOtherEntities?: GraphqlIntersectingOtherEntityForEvPickerTooltip[] | null
  label: ReactNode
}

const EntityVersionFieldsTooltipContent = (props: Props) => {
  const { fields, intersectingOtherEntities, label } = props

  const data: ColumnData[] = useMemo(() => {
    const mappedIntersectingOtherEntities =
      mapIntersectingOtherEntitiesForEvPickerTooltip(intersectingOtherEntities)

    return buildApplyFormEvPickerTooltipRows(fields, mappedIntersectingOtherEntities)
  }, [fields, intersectingOtherEntities])

  return (
    <Flex gap={4}>
      <T.Body className="text-neutral-500">{label} </T.Body>
      <Tooltip
        content={
          <>
            <T.BodyLarge>
              This information was imported from a GIS database that is integrated with GovWell and
              will be attached to your submittal.
            </T.BodyLarge>
            <FieldValueTable data={data} />
          </>
        }
        contentClassName="max-w-[min(90vw,_600px)] p-6"
        asChild={false}
      >
        <T.Body className="text-green-700">
          <Icon.FaLink />
        </T.Body>
      </Tooltip>
    </Flex>
  )
}

export default React.memo(EntityVersionFieldsTooltipContent)
